module.exports = __webpack_public_path__ + "static/colgadas-006-109a0650ea70ecb0e0965f6f126257a2.jpg";